import React from "react";

export function Sparkline({ data, color = "#22d3ee", height = 40 }) {
  if (!data || data.length === 0) return null;
  const max = Math.max(...data, 1);
  const width = 100;
  const step = width / (data.length - 1 || 1);
  const points = data.map((v, i) => `${i * step},${height - (v / max) * (height - 4) - 2}`).join(" ");

  return (
    <svg viewBox={`0 0 ${width} ${height}`} className="w-full" style={{ height }} preserveAspectRatio="none" data-testid="analytics-sparkline">
      <polyline points={points} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
